var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Action = void 0;
const react_1 = __importStar(require("react"));
const admin_core_1 = require("@wheelroom/admin-core");
const a_link_1 = require("../../elements/a-link");
const any_1 = require("../../elements/any");
const icon_1 = require("../../elements/icon");
const admin_page_preview_1 = require("@wheelroom/admin-page-preview");
const g_link_1 = require("../../elements/g-link");
const createURL = (action, isPreviewMode) => {
    const hasQuery = action.query || isPreviewMode;
    let url = action.page ? action.page.path : action.url;
    if (hasQuery) {
        url += '?';
        url += isPreviewMode ? '&preview=true' : '';
        url += action.query || '';
    }
    url += action.anchor ? '#' + action.anchor : '';
    return url;
};
const onClickHander = (eventId, adminCoreState) => {
    const globals = adminCoreState.pageProps && adminCoreState.pageProps.data.globals;
    if (globals && globals.siteEmbeds && Array.isArray(globals.siteEmbeds)) {
        globals.siteEmbeds.forEach((embed) => {
            if (embed.code && embed.type === 'js-action') {
                Function('eventId', 'props', embed.code.code)(eventId, adminCoreState.pageProps);
            }
        });
    }
};
const isPreviewMode = (adminCoreState) => {
    const store = admin_page_preview_1.getPreviewPageStore(adminCoreState);
    return !!(store && store.state.inPreviewMode);
};
const ActionGlink = (props) => {
    const { adminCoreState } = react_1.useContext(admin_core_1.AdminCoreContext);
    const heading = props.children ? props.children : props.heading;
    return (react_1.default.createElement(g_link_1.GLink, { ariaLabel: props.description, onClick: () => onClickHander(props.eventId, adminCoreState), to: createURL(props, isPreviewMode(adminCoreState)), wheel: props.wheel },
        !props.hideHeading && heading,
        props.icon && !props.hideIcon && (react_1.default.createElement(icon_1.FeatherIcon, { icon: props.icon, wheel: Object.assign(Object.assign({}, props.wheel), { style: props.wheel.style.icon }) }))));
};
const ActionAlink = (props) => {
    const { adminCoreState } = react_1.useContext(admin_core_1.AdminCoreContext);
    const heading = props.children ? props.children : props.heading;
    return (react_1.default.createElement(a_link_1.ALink, { ariaLabel: props.description, href: createURL(props, isPreviewMode(adminCoreState)), onClick: () => onClickHander(props.eventId, adminCoreState), wheel: props.wheel },
        !props.hideHeading && heading,
        props.icon && !props.hideIcon && (react_1.default.createElement(icon_1.FeatherIcon, { icon: props.icon, wheel: Object.assign(Object.assign({}, props.wheel), { style: props.wheel.style.icon }) }))));
};
const NoLink = (props) => {
    const heading = props.children ? props.children : props.heading;
    return (react_1.default.createElement(any_1.Any, { is: "span", wheel: props.wheel, ariaLabel: props.description, polyPreset: true },
        !props.hideHeading && heading,
        props.icon && !props.hideIcon && (react_1.default.createElement(icon_1.FeatherIcon, { icon: props.icon, wheel: Object.assign(Object.assign({}, props.wheel), { style: props.wheel.style.icon }) }))));
};
exports.Action = (props) => {
    if (props.page) {
        return react_1.default.createElement(ActionGlink, Object.assign({}, props));
    }
    else if (props.url) {
        return react_1.default.createElement(ActionAlink, Object.assign({}, props));
    }
    else {
        return react_1.default.createElement(NoLink, Object.assign({}, props));
    }
};
//# sourceMappingURL=action.js.map